import React from 'react';
import PropTypes from 'prop-types';

const createMarkup = content => ({ __html: content });
/* eslint-disable react/no-danger */
const RichText = ({ content }) => {
  if (typeof content === 'string' && content.match(/<|>/g)) {
    return <div dangerouslySetInnerHTML={createMarkup(content)} />;
  }

  return <span>{content}</span>;
};
/* eslint-enable react/no-danger  */

RichText.propTypes = {
  content: PropTypes.string.isRequired,
};

export default RichText;
